export default "__VITE_ASSET__244a2747__"